import React from 'react';
import { Box, Button, Divider, Grid, Tooltip, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export type Stage3JuryPairItem = {
	id: number;
	name: string;
	juror1_name: string;
	juror1_email?: string;
	juror2_name: string;
	juror2_email?: string;
	juror1_district_id: number | null;
	juror2_district_id: number | null;
	juror1_district_name: string;
	juror2_district_name: string;
	drive_folder_url: string;
	notes?: string;
	assigned_count: number;
};

type Props = {
	pairs: Stage3JuryPairItem[];
	onEdit: (pair: Stage3JuryPairItem) => void;
	onDelete: (pair: Stage3JuryPairItem) => void;
	juryVerifyStatusByPairId: Record<number, boolean>;
	juryVerifyErrorByPairId: Record<number, string>;
};

const Stage3JuryPairsList = ({ pairs, onEdit, onDelete, juryVerifyStatusByPairId, juryVerifyErrorByPairId }: Props) => (
	<Box sx={{ mt: 2 }}>
		<Typography variant='subtitle1'>Lista komisji</Typography>
		<Divider sx={{ mb: 1, mt: 0.5 }} />
		{pairs.length === 0 && <Typography variant='body2'>Brak zdefiniowanych komisji.</Typography>}
		{pairs.map((pair) => (
			<Box
				key={pair.id}
				sx={{ py: 1 }}
			>
				<Grid
					container
					spacing={1}
					alignItems='center'
				>
					<Grid
						item
						xs={12}
						md={5}
					>
						<Typography variant='body2'>
							<b>{pair.name}</b> ({pair.assigned_count} przypisanych)
						</Typography>
						<Typography variant='caption'>
							{pair.juror1_name} [{pair.juror1_district_name || 'dowolny'}] / {pair.juror2_name} [
							{pair.juror2_district_name || 'dowolny'}]
						</Typography>
						{(pair.juror1_email || pair.juror2_email) && (
							<Typography
								variant='caption'
								sx={{ display: 'block' }}
							>
								Email: {pair.juror1_email || '-'} / {pair.juror2_email || '-'}
							</Typography>
						)}
						{pair.drive_folder_url && (
							<Typography
								variant='caption'
								sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
							>
								Folder: {pair.drive_folder_url}
								{juryVerifyStatusByPairId[pair.id] && (
									<Tooltip title='Folder zweryfikowany'>
										<CheckCircleIcon
											fontSize='inherit'
											color='success'
										/>
									</Tooltip>
								)}
							</Typography>
						)}
						{!juryVerifyStatusByPairId[pair.id] && juryVerifyErrorByPairId[pair.id] && (
							<Typography
								variant='caption'
								color='error.main'
								sx={{ display: 'block' }}
							>
								{juryVerifyErrorByPairId[pair.id]}
							</Typography>
						)}
					</Grid>
					<Grid
						item
						xs={12}
						md={7}
						sx={{ display: 'flex', gap: 1, justifyContent: { md: 'flex-end' }, flexWrap: 'wrap' }}
					>
						<Button
							size='small'
							variant='outlined'
							onClick={() => onEdit(pair)}
						>
							Edytuj
						</Button>
						<Button
							size='small'
							color='error'
							variant='outlined'
							onClick={() => onDelete(pair)}
						>
							Usuń
						</Button>
					</Grid>
				</Grid>
				<Divider sx={{ mt: 1 }} />
			</Box>
		))}
	</Box>
);

export default Stage3JuryPairsList;
